module.exports = ".dot {\n  height: 10px;\n  width: 10px;\n  border-radius: 50%;\n  display: inline-block;\n  border: 1; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/issue-web/component/issue-action/issue-action.component.scss
// module id = ./src/app/issue-web/component/issue-action/issue-action.component.scss
// module chunks = main